import { ErrorMessage, Formik, Form, Field } from 'formik';
import React from 'react';
import {
  createActionSettingsSchema,
  extractParameters,
  getFieldInfoByName,
} from '../collection/Util';
import CustomLoader from '../../../common/CustomLoader';
import 'ace-builds/src-noconflict/mode-javascript';
import 'ace-builds/src-noconflict/theme-monokai';
import AceEditor from 'react-ace';
import FormFieldWithLabel from '../../../common/FormFieldWithLabel';

export const JavaScriptEditorForm = ({
  projectId,
  selectedEvent,
  eventAction,
  actionData,
  events,
  actions,
  hideModal,
  showLoaderForAction,
  version,
}) => {
  const handleSubmit = (values) => {
    const parameters = extractParameters(values, actionData);
    const actionFormData = { ...eventAction, parameters };
    actions.updateAction({
      projectId,
      version,
      eventId: selectedEvent.uuid,
      data: actionFormData,
    });
    hideModal();
  };

  return (
    <div className="show_scrollbar">
      <Formik
        enableReinitialize={true}
        initialValues={createActionSettingsSchema(actionData, eventAction)}
        onSubmit={handleSubmit}
      >
        {({ setFieldValue, setFieldTouched, resetForm, values }) => {
          return (
            <Form className="form-horizontal">
              <div className="mx-auto">
                <div className="col-12">
                  <div className="form-group">
                    <AceEditor
                      mode="javascript"
                      theme="github"
                      name="runJavaScript"
                      value={values.runJavaScript}
                      onChange={(value) => setFieldValue('runJavaScript', value)}
                      onBlur={() => setFieldTouched('runJavaScript', true)}
                      rows={10}
                      fontSize={16}
                      showPrintMargin={false}
                      width="100%"
                      placeholder={`Write your JavaScript code here.. and execute it on an event trigger.\nExample: console.log('Custom script executed!');`}
                    />
                    <ErrorMessage name="runJavaScript">
                      {(msg) => <p className="text-error">{msg}</p>}
                    </ErrorMessage>
                  </div>
                </div>
                <div className="col-12">
                  <div className="form-group">
                    <FormFieldWithLabel
                      label="Success Message"
                      icon="text"
                      infoIcon
                      infoDescription={getFieldInfoByName('successMessage')}
                    >
                      <Field
                        name="successMessage"
                        type="text"
                        value={values.successMessage}
                        placeholder="(Optional) Enter custom success message."
                        className="form-control form-control-sm"
                      />
                    </FormFieldWithLabel>
                  </div>
                  <div className="form-group">
                    <FormFieldWithLabel
                      label="Error Message"
                      icon="text"
                      infoIcon
                      infoDescription={getFieldInfoByName('errorMessage')}
                    >
                      <Field
                        name="errorMessage"
                        type="text"
                        value={values.errorMessage}
                        placeholder="(Optional) Enter custom error message."
                        className="form-control form-control-sm"
                      />
                    </FormFieldWithLabel>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6 text-left">
                    <button
                      type="button"
                      className="btn btn-outline-secondary btn-md"
                      onClick={hideModal}
                    >
                      <i className="wb webconnect-times"></i>&nbsp;Cancel
                    </button>
                    &nbsp;&nbsp;
                    <button
                      type="button"
                      className="btn btn-outline-secondary  btn-md"
                      onClick={() => {
                        resetForm({ values: { runJavaScript: '' } });
                        setFieldValue('runJavaScript', '');
                      }}
                    >
                      <i className="wb webconnect-eraser"></i>&nbsp;Reset
                    </button>
                  </div>
                  <div className="col-md-6 text-right">
                    <button type="submit" className="btn btn-theme-submit btn-md">
                      <i className="wb webconnect-save-regular"></i>&nbsp;Save&nbsp;
                      <CustomLoader loading={showLoaderForAction} />
                    </button>
                  </div>
                </div>
              </div>
            </Form>
          );
        }}
      </Formik>
    </div>
  );
};
